import { ChevronLeft, ChevronRight, Gift } from "lucide-react";
import { TIME_SLOTS, humanSlot } from "@/data/collections";

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const tone = { approved: ["#E1E8D8", "#3F5B33"], denied: ["#EED6D2", "#8A2E2E"], pending: ["#F4E3C8", "#8A5A20"] };

export const startOfWeek = (d) => { const s = new Date(d); s.setHours(0, 0, 0, 0); s.setDate(s.getDate() - s.getDay()); return s; };

export const WeekView = ({ weekStart, setWeekStart, byDate, onSelect, selectedDay, onSelectDay }) => {
  const days = Array.from({ length: 7 }, (_, i) => { const d = new Date(weekStart); d.setDate(d.getDate() + i); return d; });
  const end = days[6];
  const total = days.reduce((n, d) => n + (byDate[ymd(d)] || []).length, 0);
  const shift = (n) => { const d = new Date(weekStart); d.setDate(d.getDate() + n * 7); setWeekStart(d); };

  return (
    <div className="border p-4 sm:p-6" style={{ borderColor: "var(--pp-border)", backgroundColor: "var(--pp-cream-card)" }} data-testid="admin-week-view">
      <div className="flex items-center justify-between mb-5">
        <button onClick={() => shift(-1)} className="h-9 w-9 inline-flex items-center justify-center hover:bg-[var(--pp-cream)]" data-testid="admin-week-prev"><ChevronLeft className="h-4 w-4" /></button>
        <div className="text-center">
          <div className="font-serif-display text-2xl" style={{ color: "var(--pp-burgundy)" }} data-testid="admin-week-title">
            {weekStart.toLocaleDateString(undefined, { month: "short", day: "numeric" })} – {end.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
          </div>
          <div className="text-xs" style={{ color: "var(--pp-text-muted)" }}>{total} install{total === 1 ? "" : "s"} this week</div>
        </div>
        <button onClick={() => shift(1)} className="h-9 w-9 inline-flex items-center justify-center hover:bg-[var(--pp-cream)]" data-testid="admin-week-next"><ChevronRight className="h-4 w-4" /></button>
      </div>

      <div className="overflow-x-auto">
        <div className="grid" style={{ gridTemplateColumns: "64px repeat(7, minmax(0, 1fr))" }}>
          <div />
          {days.map((d) => {
            const key = ymd(d); const active = selectedDay === key; const count = (byDate[key] || []).length;
            return (
              <button key={key} onClick={() => onSelectDay(active ? null : key)} data-testid={`admin-week-day-${key}`}
                className="text-center py-2 border-b transition-colors hover:bg-[var(--pp-parchment)]"
                style={{ borderColor: "var(--pp-border)", backgroundColor: active ? "#F6E6D4" : "transparent" }}>
                <div className="text-[10px] uppercase tracking-widest" style={{ color: "var(--pp-text-muted)" }}>{d.toLocaleDateString(undefined, { weekday: "short" })}</div>
                <div className="font-serif-display text-xl" style={{ color: active ? "var(--pp-terracotta)" : "var(--pp-burgundy)" }}>{d.getDate()}</div>
                {count > 0 && <div className="text-[10px]" style={{ color: "var(--pp-text-muted)" }}>{count}</div>}
              </button>
            );
          })}
          {TIME_SLOTS.map((slot) => (
            <Row key={slot} slot={slot} days={days} byDate={byDate} onSelect={onSelect} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Row = ({ slot, days, byDate, onSelect }) => (
  <>
    <div className="py-2 pr-1 text-[10px] border-b" style={{ color: "var(--pp-text-muted)", borderColor: "var(--pp-border)" }}>{humanSlot(slot)}</div>
    {days.map((d) => {
      const items = (byDate[ymd(d)] || []).filter((b) => b.time_slot === slot);
      const sunday = d.getDay() === 0;
      return (
        <div key={ymd(d)} className="min-h-[52px] p-1 border-b border-l space-y-1" style={{ borderColor: "var(--pp-border)", backgroundColor: sunday ? "var(--pp-parchment)" : "transparent" }}>
          {items.map((b) => (
            <button key={b.id} onClick={() => onSelect(b)} data-testid={`admin-week-appt-${b.reference}`}
              className="block w-full text-left text-[10px] px-1.5 py-1 leading-tight truncate"
              style={{ backgroundColor: tone[b.status][0], color: tone[b.status][1] }} title={`${b.full_name} · ${b.collection_name}`}>
              <span className="inline-flex items-center gap-1">{b.full_name.split(" ")[0]}{b.is_gift && <Gift className="h-2.5 w-2.5" />}</span>
              <div className="opacity-70 truncate">{b.size_label}</div>
            </button>
          ))}
        </div>
      );
    })}
  </>
);
